import { Button, ButtonGroup, Divider, DrawerBody, DrawerFooter, useDisclosure, useToast } from "@chakra-ui/react"
import { Drawer, Form } from "components"
import { API } from "config"
import { Moment } from "config"
import { Mask } from "config"
import { useEmployee } from "hooks"
import { useState } from "react"
import { Authenticate } from "screens"

export default function Edit({ data, ...props }){

    const toast = useToast()
    const employee = useEmployee(data?.id)
    const [ form, setForm ] = useState({})
    const [ errors, setErrors ] = useState()
    const [ loading, setLoading ] = useState()
    const auth = useDisclosure()

    const onChange = ({ target }) => {
        const { name, value } = target

        switch(name){
            case 'mobile': setForm({...form, [name]: Mask.mobile(value)}); break;
            case 'doc_cpf': setForm({...form, [name]: Mask.cpf(value)}); break;
            case 'dob': setForm({...form, [name]: Mask.date(value)}); break;
            default: setForm({...form, [name]: value}); break;
        }
    }

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put(`/employees/${employee.data.id}`, form)
            toast({ title: 'Dados do funcionário atualizados.', status: 'info' })
            employee.refetch()
            props.onClose()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível atualizar o funcionário.', description: err?.response?.data?.message, status: 'warning'})
        }
        
        setLoading(false)
    }

    return(
    <>
    <Drawer size="md" loading={employee.isLoading || loading} {...props}>
        <DrawerBody>
            <Form.Form onSubmit={auth.onOpen}>

                <Form.Text
                    required
                    label="Nome:"
                    name="name"
                    value={form?.name}
                    error={errors?.name}
                    defaultValue={employee.data?.name}
                    onChange={onChange}
                    isDisabled={loading}
                    size="lg"
                    fontWeight="bold"
                />

                <Form.Text
                    required
                    placeholder="Cargo/Função"
                    name="tagline"
                    value={form?.tagline}
                    error={errors?.tagline}
                    defaultValue={employee.data?.tagline}
                    onChange={onChange}
                    isDisabled={loading}
                />

                <Form.Text
                    required
                    label="Data de nascimento:"
                    name="dob"
                    value={form?.dob}
                    error={errors?.dob}
                    defaultValue={Moment(employee.data?.dob).format('DD/MM/YYYY')}
                    onChange={onChange}
                    isDisabled={loading}
                />

                <Divider />

                <Form.Text
                    required
                    type="email"
                    label="E-mail:"
                    name="email"
                    value={form?.email}
                    error={errors?.email}
                    defaultValue={employee.data?.email}
                    onChange={onChange}
                    isDisabled={loading}
                />

                <Form.Text
                    required
                    type="tel"
                    label="Celular/Whatsapp:"
                    name="mobile"
                    value={form?.mobile}
                    error={errors?.mobile}
                    defaultValue={Mask.mobile(employee.data?.mobile)}
                    onChange={onChange}
                    isDisabled={loading}
                />

                <Divider />

                <Form.Text
                    required
                    label="CPF:"
                    name="doc_cpf"
                    value={form?.doc_cpf}
                    error={errors?.doc_cpf}
                    defaultValue={Mask.cpf(employee.data?.doc_cpf ?? '')}
                    onChange={onChange}
                    isDisabled={loading}
                />

            </Form.Form>
        </DrawerBody>

        <DrawerFooter>
            <ButtonGroup isDisabled={loading}>
                <Button children="Salvar" onClick={auth.onOpen} isLoading={loading} />
                <Button children="Cancelar" colorScheme="red" />
            </ButtonGroup>
        </DrawerFooter>
    </Drawer>

    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}